import ActionTypes from '../constants/ActionTypes';
import Checkpoints from '../constants/Checkpoints';
import JobStates from '../constants/JobStates';

export function isJobLoaded(state, id) {
  return !!(state.jobs.status[id] && state.jobs.status[id] === ActionTypes.FETCH_JOB_SUCCESS);
}

export function getJobById(state, id) {
  return state.jobs.list[id] || {};
}

export function getJobInvitationsById(state, id) {
  return state.jobs.invitations[id];
}

export function getJobConnectionsById(state, id) {
  const connections = (state.jobs.connections[id] && state.jobs.connections[id].connections) || [];
  return connections.map(c => ({
    waitlistStatus: getConnectionWaitlistStatusById(state, c.id),
    ...c
  }));
}

export function getConnectionWaitlistStatusById(state, id) {
  return state.jobs.connectionWaitlistStatus[id];
}

export function getConnectMoreStatusById(state, id) {
  return state.jobs.connectMoreStatus[id];
}

export function hasSeenCheckpoint(state, id, checkpoint) {
  return !!getCheckpoint(state, id, checkpoint);
}

export function getCheckpoint(state, id, checkpoint) {
  const key = `${id}-${checkpoint}`;
  return state.jobs.checkpoints[key];
}

export function isFirstView(state, id) {
  return !!state.jobs.isFirstView[id];
}

export function getJobUIState(state, id) {
  const { status } = getJobById(state, id);
  if ([7, 11].includes(status)) return JobStates.NEEDS_MORE_INFO;
  if (isFirstView(state, id)) {
    // if (getHiprojectsModalState(state)) return JobStates.HIPROJECTS;
    if (!hasSeenCheckpoint(state, id, Checkpoints.MODERATION_FINISHED)) return JobStates.MODERATION;
    if (!hasSeenCheckpoint(state, id, Checkpoints.INVITE_ANIMATION_FINISHED))
      return JobStates.INVITE_ANIMATION;
  }
  if ([1, 2, 3].includes(status)) return JobStates.WAITING_FOR_CONNECTION;
  return JobStates.CONNECTED;
}

export function timeSinceCheckpoint(state, id, checkpoint, now) {
  if (!hasSeenCheckpoint(state, id)) return;
  const { time } = getCheckpoint(state, id);
  const comparedTo = now || +new Date();
  return comparedTo - time;
}

export function getCloseJobSuccessMessage(state) {
  return state.jobs.closeJob;
}
